/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const orderState = () => ({
  orderDetails: null,
  shopDomain: null,
  paymentMode: null,
  orderPlaced: false,
  razorpayDetails: {
    loading: false
  },
  mobileView: {
    showOrderDetails: false
  },
  enableCod: null
});

const orderSuccess = (domain, payload) => {
  window.parent.postMessage(payload, `https://${domain}`);
};

const orderSlice = createSlice({
  name: "order",
  initialState: orderState(),
  reducers: {
    setShopDomain(state, { payload }) {
      state.shopDomain = payload;
    },
    setRazorpayDetails(state, { payload = {} }) {
      state.razorpayDetails.key = payload.razorpayKey;
      state.razorpayDetails.paymentGatewayTxnId = payload.razorpayResponse?.id;
    },
    setPaymentMode(state, { payload }) {
      state.paymentMode = payload;
    },
    setOrderDetails(state, { payload }) {
      state.orderDetails = { ...payload };
      if (
        state.orderDetails.orderStatus === "pre-completed" &&
        state.orderDetails.paymentMode === "cod"
      ) {
        state.orderPlaced = true;
        orderSuccess(state.shopDomain, { orderPlaced: true, redirect: false });
      }
    },
    setOrderPlaced(state) {
      state.orderPlaced = true;
      orderSuccess(state.shopDomain, { orderPlaced: true, redirect: false });
    },
    afterOrderPlaced(state) {
      orderSuccess(state.shopDomain, { redirect: true });
    },
    setMobileViewProperties(state, { payload }) {
      state.mobileView = { ...state.mobileView, ...payload };
    },
    resetOrderStore() {},
    setEnableCod(state, { payload }) {
      state.enableCod = payload;
    }
  }
});

export const {
  setShopDomain,
  setPaymentMode,
  setEnableCod,
  setOrderDetails,
  setRazorpayDetails,
  resetOrderStore,
  afterOrderPlaced,
  setOrderPlaced,
  setMobileViewProperties
} = orderSlice.actions;

export default orderSlice.reducer;
